function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 4,
  y: 4,
  width: 4,
  height: 4,
  rx: 1
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 4,
  y: 10,
  width: 4,
  height: 4,
  rx: 1
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 4h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM11 10h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 4,
  y: 16,
  width: 4,
  height: 4,
  rx: 1
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 16h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"
});

var SvgIcModeList24 = function SvgIcModeList24(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _ref, _ref2, _ref3, _ref4, _ref5));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjUgKDY3NDY5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pYy1tb2RlLWxpc3QtMjQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L01vZGUtTGlzdCIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03IiB4PSI0IiB5PSI0IiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTciIHg9IjQiIHk9IjEwIiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICA8cGF0aCBkPSJNMTEsNCBMMTksNCBDMTkuNTUyMjg0Nyw0IDIwLDQuNDQ3NzE1MjUgMjAsNSBMMjAsNyBDMjAsNy41NTIyODQ3NSAxOS41NTIyODQ3LDggMTksOCBMMTEsOCBDMTAuNDQ3NzE1Myw4IDEwLDcuNTUyMjg0NzUgMTAsNyBMMTAsNSBDMTAsNC40NDc3MTUyNSAxMC40NDc3MTUzLDQgMTEsNCBaIiBpZD0iUmVjdGFuZ2xlLTciPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTExLDEwIEwxOSwxMCBDMTkuNTUyMjg0NywxMCAyMCwxMC40NDc3MTUzIDIwLDExIEwyMCwxMyBDMjAsMTMuNTUyMjg0NyAxOS41NTIyODQ3LDE0IDE5LDE0IEwxMSwxNCBDMTAuNDQ3NzE1MywxNCAxMCwxMy41NTIyODQ3IDEwLDEzIEwxMCwxMSBDMTAsMTAuNDQ3NzE1MyAxMC40NDc3MTUzLDEwIDExLDEwIFoiIGlkPSJSZWN0YW5nbGUtNyI+PC9wYXRoPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTciIHg9IjQiIHk9IjE2IiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICA8cGF0aCBkPSJNMTEsMTYgTDE5LDE2IEMxOS41NTIyODQ3LDE2IDIwLDE2LjQ0NzcxNTMgMjAsMTcgTDIwLDE5IEMyMCwxOS41NTIyODQ3IDE5LjU1MjI4NDcsMjAgMTksMjAgTDExLDIwIEMxMC40NDc3MTUzLDIwIDEwLDE5LjU1MjI4NDcgMTAsMTkgTDEwLDE3IEMxMCwxNi40NDc3MTUzIDEwLjQ0NzcxNTMsMTYgMTEsMTYgWiIgaWQ9IlJlY3RhbmdsZS03Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgIcModeList24 as ReactComponent };